const siteConfig = {
  siteUrl: 'https://omens.com.br/', // Site domain. Do not include a trailing slash!
  siteName: 'Omens',

  logo: '/omens-social-og.webp',
  blogPrefix: '/blog',

  postsPerPage: 12, // Number of posts shown on paginated pages (changes this requires
  // sometimes to delete the cache)

  siteTitleMeta: 'Omens', // This allows an alternative site title for meta data for pages.
  siteDescriptionMeta:
    'Consultas online com médicos especialistas. Entrega de remédios à domicílio por meio de uma farmácia certificada.', // This allows an alternative site description for meta data for pages.

  shareImage: '/omens-social-og.webp', // fallback image for meta data. Will be used, when no post/tag/author image specified. 1200x1200 is recommended
  shareImageWidth: 1200, // Change to the width of your default share image
  shareImageHeight: 1200, // Change to the height of your default share image

  shortTitle: 'Omens', // Used for App manifest e.g. Mobile Home Screen
  siteIcon: '/favicon.png', // Trying to move this to not static ---ORIGINAL COMMENT : Logo in /static dir used for SEO, RSS, and App manifest
  backgroundColor: '#71E0DC', // Used for Offline Manifest
  themeColor: '#082D0F', // Used for Offline Manifest
  frontAppUrl: 'https://omens.com.br',

  twitter: '@OmensBr',

  // Meta (Facebook) domain verification, on every Omens page head (CharlesMeta, GeoHead, OmensSeoHead).
  facebookDomainVerification: '5tv92hyat43umk69220bunz3mbuzpx'
}

export default siteConfig
